
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/components/in-place",
      function () {
        return require("private-next-pages/components/in-place.md");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/components/in-place"])
      });
    }
  